import styled from 'styled-components';
import Select from 'react-select';

export const Container = styled.div`
  width: auto;
  min-width: 200px;
  margin: 0;
  padding: 15px;
  &.fluid {
    width: 100%;
  }
`;

export const ReactSelect = styled(Select)`
	font-family: 'AvenirNext';
	font-size: 18px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: 0.5px;
	color: #bfbfbf;
`
